<script setup lang="ts">
const showInfo = ref(true);
</script>

<template>
  <div
    v-if="showInfo"
    :class="$style.cryptoInfo"
  >
    <div class="alert alert-error mb-2"> Integração em andamento... </div>
  </div>
</template>

<style module lang="scss">
.cryptoInfo {
  @apply mb-4;
}
</style>
